import React from 'react';
import Avatar from 'react-avatar';
import { Icon } from 'semantic-ui-react';

export default class RecordUtils {
    static getName(record) {
        return {
            firstLine: record.first_name,
            secondLine: `${record.last_name} ${record.suffix || ""}`
        }
    }

    static generateCallPayload(contact_id, destination) {
        return {
            "contact_id": contact_id,
            "destination": destination,
        }
    }

    static generateRecordPath(account_stage, contact_id, account_id) {
        return `/contact/${contact_id}`;
    }

    static fieldIsShown(field_name_to_check, fields) {
        return fields.findIndex(({ field_name, deleted }) => field_name_to_check === field_name && !deleted) !== -1;
    }

    static generateUserOptions(users) {
        return users.map(({ user_id, first_name, last_name, email }) => {
            const text = first_name || last_name ? `${first_name || ''} ${last_name || ''}` : "Unknown Name";
            return {
                key: Number(user_id),
                value: Number(user_id),
                text,
                content: (
                    <div style={{ verticalAlign: 'middle' }}>
                        <Avatar name={text} maxInitials={2} round size='3em' /> <div style={{ display: "inline-block", paddingLeft: "1em" }}>
                            <div><b>{text}</b></div>
                            <div>{email}</div>
                        </div>
                    </div>
                )
            }
        })
    }

    static updateMain(items, update, onChange, property = 'main') {
        const indexOfPreviousMain = items.findIndex(item => item[property]);
        if (indexOfPreviousMain !== -1) {
            update(indexOfPreviousMain, { ...items[indexOfPreviousMain], [property]: false });
        }
        onChange();
    }

    static removeItem(items, index, update, remove) {
        const isMain = items[index].main;
        if (isMain) {
            const indexOfItemToSetAsMain = (index + 1) % items.length;
            update(indexOfItemToSetAsMain, { ...items[indexOfItemToSetAsMain], main: true });
        }
        remove(index);
    }

    static getRelationOption(relation) {
        const text = relation.related_name || relation.contact_name;
        const [first,] = text.split("-");
        const isLead = first === "Lead ";
        const iconName = {
                customer: 'fas fa-user-crown',
            customer_pipeline: 'fas fa-crown',
            pipeline_stage: isLead ? 'fas fa-address-card' : 'fas fa-filter-circle-dollar'
        }[relation.related_type] || '';
        const related_id = relation.related_id;

        return {
            key: related_id,
            value: related_id,
            text: <>
                <Icon className={iconName} /> {text}
            </>
        };
    };
}
